// extracted by mini-css-extract-plugin
export default {"list":"link-list-list--b26ee"};